import "./src/fonts/global.css"
require("katex/dist/katex.min.css")
